import { contactCard } from './contactCard';

export const closingAttorneyContactCard = contactCard(
  'additionalContacts.closingAttorney',
  'closingAttorney',
);
